import { render, staticRenderFns } from "./ModalOtherBranch.vue?vue&type=template&id=46f25899&scoped=true"
import script from "./ModalOtherBranch.vue?vue&type=script&lang=js"
export * from "./ModalOtherBranch.vue?vue&type=script&lang=js"
import style0 from "./ModalOtherBranch.vue?vue&type=style&index=0&id=46f25899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f25899",
  null
  
)

export default component.exports